export { default as DraftsView } from './DraftsView'
export { default as StyledDraftsView } from './DraftsView.Styled'

export { useDraftActions } from './useDraftActions'
export { DraftItem } from './DraftItem'

export { default as DraftsUploadPhotos } from './DraftsUploadPhotos'
export { default as StyledDraftsUploadPhotos } from './DraftsUploadPhotos.Styled'

export { default as DraftsHeader } from './DraftsHeader'
export { default as StyledDraftsHeader } from './DraftsHeader.Styled'

export const DraftSortOptions = [
  {
    label: 'Your Uploads',
    value: 'uploads'
  },
  {
    label: 'Custom Order',
    value: 'custom'
  },
  {
    label: 'Date Created',
    value: 'created'
  },
  {
    label: 'Date Modified',
    value: 'modified'
  }
]
